import { render, staticRenderFns } from "./AlertesEditor.vue?vue&type=template&id=e08e1132&scoped=true"
import script from "./AlertesEditor.vue?vue&type=script&lang=js"
export * from "./AlertesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08e1132",
  null
  
)

export default component.exports